<template>
  <!-- Modal Email Confirmando Registro -->
  <div
    class="modal fade"
    id="confirmRegisterModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="confirmRegisterModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-t="'confirm_modals.titulo_registro'"></h5>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-only-text">
          <p v-t="'confirm_modals.mensaje_registro'"></p>
        </div>
        <div class="modal-footer">
          <a
            href="#"
            class="material-btn bt_red"
            role="button"
            data-bs-dismiss="modal"
            aria-label="Cerrar"
            v-t="'boton.entendido'"
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    $(document).ready(function () {
      $("#confirmRegisterModal").on("show.bs.modal", function (e) {
        document.getElementById("app").style.position = "relative";
      });

      $("#confirmRegisterModal").on("hidden.bs.modal", function () {
        document.getElementById("app").style.position = "fixed";
      });
    });
  },
  methods: {
    confirm() {},
  },
};
</script>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/confirmModals.json" />
